import { Box, Flex, Title } from "@mantine/core";
import SMEFeedback from "src/components/SMEFeedback";

export const SMERoute = () => {
    return (
        <Flex p="xl" direction="column" gap="md">
            <Flex justify="space-between">
                <Title lh={2} c="purple.8" order={2} style={{ textTransform: "uppercase" }}>
                    SME Feedback
                </Title>
            </Flex>
            <Box>
                <SMEFeedback />
            </Box>
        </Flex>
    );
};
